import { render, staticRenderFns } from "./PackageAndSchedule.vue?vue&type=template&id=c72d8908&scoped=true"
import script from "./PackageAndSchedule.vue?vue&type=script&lang=ts"
export * from "./PackageAndSchedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72d8908",
  null
  
)

export default component.exports